export default "__VITE_ASSET__uvdxqaVk__"